module.exports = __webpack_public_path__ + "assets/img/department-placeholder.jpg";